import { ROUTE_IDS } from './routes/ids.js';
import { TRANSACTION_APPROVE, TRANSACTION_REVERSE } from '../operations/operation-ids.js';
export const ROUTE_INTENT_IDS = {
    TRANSACTION_LIST: 'intent.transaction.list',
    TRANSACTION_APPROVALS: 'intent.transaction.approvals',
    TRANSACTION_REVERSALS: 'intent.transaction.reversals',
    INSTRUMENT_LIST: 'intent.instrument.list',
    IMPORT_LIST: 'intent.import.list',
    CORPORATE_ACTION_LIST: 'intent.corporateAction.list',
    RECONCILIATION_LIST: 'intent.reconciliation.list',
    FACT_BATCH_LIST: 'intent.factBatch.list',
    DATA_HOLDINGS: 'intent.dataHoldings.list',
    ADMIN_USERS: 'intent.admin.users',
    ADMIN_ROLES: 'intent.admin.roles',
    ADMIN_ORGANIZATION: 'intent.admin.organization',
    ADMIN_AUDIT: 'intent.admin.audit',
};
export const ROUTE_INTENT_REGISTRY = Object.freeze({
    [ROUTE_INTENT_IDS.TRANSACTION_LIST]: {
        id: ROUTE_INTENT_IDS.TRANSACTION_LIST,
        module: 'transactions',
        feature: 'transactions.list',
        routeId: 'transactions',
        operationId: 'investment.transaction.list',
        labelKey: 'intents.transaction.list.label',
        descriptionKey: 'intents.transaction.list.description',
        landmark: 'page-transactions-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.TRANSACTION_APPROVALS]: {
        id: ROUTE_INTENT_IDS.TRANSACTION_APPROVALS,
        module: 'transactions',
        feature: 'transactions.approvals',
        routeId: ROUTE_IDS.TRANSACTION_APPROVALS,
        operationId: TRANSACTION_APPROVE,
        labelKey: 'intents.transaction.approvals.label',
        descriptionKey: 'intents.transaction.approvals.description',
        landmark: 'page-transactions-approvals',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.TRANSACTION_REVERSALS]: {
        id: ROUTE_INTENT_IDS.TRANSACTION_REVERSALS,
        module: 'transactions',
        feature: 'transactions.reversals',
        routeId: ROUTE_IDS.TRANSACTION_REVERSALS,
        operationId: TRANSACTION_REVERSE,
        labelKey: 'intents.transaction.reversals.label',
        descriptionKey: 'intents.transaction.reversals.description',
        landmark: 'page-transactions-reversals',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.INSTRUMENT_LIST]: {
        id: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
        module: 'instruments',
        feature: 'data.instruments',
        routeId: 'data-instruments',
        operationId: 'investment.instrument.list',
        labelKey: 'intents.instrument.list.label',
        descriptionKey: 'intents.instrument.list.description',
        landmark: 'page-instruments-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.IMPORT_LIST]: {
        id: ROUTE_INTENT_IDS.IMPORT_LIST,
        module: 'import',
        feature: 'data.imports',
        routeId: 'data-imports',
        operationId: 'import.list',
        labelKey: 'intents.import.list.label',
        descriptionKey: 'intents.import.list.description',
        landmark: 'page-imports-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.CORPORATE_ACTION_LIST]: {
        id: ROUTE_INTENT_IDS.CORPORATE_ACTION_LIST,
        module: 'corporateActions',
        feature: 'data.corporateActions',
        routeId: 'data-corporate-actions',
        operationId: 'investment.corporateAction.list',
        labelKey: 'intents.corporateAction.list.label',
        descriptionKey: 'intents.corporateAction.list.description',
        landmark: 'page-corporate-actions-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.RECONCILIATION_LIST]: {
        id: ROUTE_INTENT_IDS.RECONCILIATION_LIST,
        module: 'reconciliation',
        feature: 'data.reconciliation',
        routeId: 'data-reconciliation',
        operationId: 'accounting.reconciliation.list',
        labelKey: 'intents.reconciliation.list.label',
        descriptionKey: 'intents.reconciliation.list.description',
        landmark: 'page-reconciliation-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.FACT_BATCH_LIST]: {
        id: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
        module: 'facts',
        feature: 'data.factBatches',
        routeId: 'data-fact-batches',
        operationId: 'investment.fact.batches.list',
        labelKey: 'intents.factBatch.list.label',
        descriptionKey: 'intents.factBatch.list.description',
        landmark: 'page-fact-batches-list',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.DATA_HOLDINGS]: {
        id: ROUTE_INTENT_IDS.DATA_HOLDINGS,
        module: 'holdings',
        feature: 'data.holdings',
        routeId: 'data-holdings',
        operationId: 'holdings.view',
        labelKey: 'intents.dataHoldings.list.label',
        descriptionKey: 'intents.dataHoldings.list.description',
        landmark: 'page-data-holdings-list',
        parameters: [],
        availableFromHub: false,
    },
    [ROUTE_INTENT_IDS.ADMIN_USERS]: {
        id: ROUTE_INTENT_IDS.ADMIN_USERS,
        module: 'admin',
        feature: 'admin.users',
        routeId: 'users',
        operationId: 'admin.users.view',
        labelKey: 'intents.admin.users.label',
        descriptionKey: 'intents.admin.users.description',
        landmark: 'page-admin-users',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.ADMIN_ROLES]: {
        id: ROUTE_INTENT_IDS.ADMIN_ROLES,
        module: 'admin',
        feature: 'admin.roles',
        routeId: 'roles',
        operationId: 'admin.roles.view',
        labelKey: 'intents.admin.roles.label',
        descriptionKey: 'intents.admin.roles.description',
        landmark: 'page-admin-roles',
        parameters: [],
        availableFromHub: false,
    },
    [ROUTE_INTENT_IDS.ADMIN_ORGANIZATION]: {
        id: ROUTE_INTENT_IDS.ADMIN_ORGANIZATION,
        module: 'admin',
        feature: 'admin.organization',
        routeId: 'organization-profile',
        operationId: 'organization.profile.read',
        labelKey: 'intents.admin.organization.label',
        descriptionKey: 'intents.admin.organization.description',
        landmark: 'page-admin-organization',
        parameters: [],
        availableFromHub: true,
    },
    [ROUTE_INTENT_IDS.ADMIN_AUDIT]: {
        id: ROUTE_INTENT_IDS.ADMIN_AUDIT,
        module: 'admin',
        feature: 'admin.audit',
        routeId: 'audit-explorer',
        operationId: 'admin.audit.view',
        labelKey: 'intents.admin.audit.label',
        descriptionKey: 'intents.admin.audit.description',
        landmark: 'page-admin-audit',
        parameters: [],
        availableFromHub: true,
    },
});
export function getRouteIntentById(id) {
    return ROUTE_INTENT_REGISTRY[id];
}
